import React, { Component } from 'react';
import { Route, Switch, BrowserRouter } from 'react-router-dom';
import { Layout, message, Spin } from 'antd';
import { connect } from 'react-redux';
import Analytics from 'react-router-ga';
import { CoinAction, ExchangeAction, SetupAction, UserAction, PairAction } from './actions';
import { bindActionCreators } from 'redux';

import Header from './components/Header';
import AuthWrapper from './components/AuthWrapper';
import SideBar from './components/SideBar';
import SideBarMain from './components/SideBar/SideBarMain';

import {
	ActivationEmailRequest,
	Home,
	Exchange,
	Login,
	CreateExchange,
	Credit,
	RecoverAccount,
	ResetPw,
	// SignUp,
	User,
	Verify,
	// WalletList,
	// PluginList,
	// PluginHome,
	PluginApps,
	PluginDetails,
	Help,
	// Project,
	// ProjectList,
	Dashboard,
	General,
	Financial,
	Trading,
	Hosting,
	ExchangeBilling,
	Users,
	VerifyPage,
	// UserTiers,
	// Members,
	// APIkeys
} from './containers';
import { removeCookie, hideChat, showChat } from './common/utils';
import { getUserInfo, getExchange, getCoins, getPairs } from './common/fetch';
import { ASSET_TYPE_LIST } from './config/constants';
import CustomizeSection from './containers/CustomizeSection';
import Kyc from './containers/Kyc';
import VerifyCode from './containers/VerifyCode';
import { Wrapper } from './style'

const { Content } = Layout;

message.config({
	duration: 2,
	maxCount: 3,
});

class Routes extends Component {
	state = {
		isLoaded: false,
		isLogin: false,
	};

	componentDidMount() {
		this.getData();
	}

	getData = async () => {
		const { exchangeAction, setupAction } = this.props;
		try {
			await this.getAvailableCurrency();
		} catch (error) {
			console.error(error);
		}
		try {
			await this.getTradingPairs();
		} catch (error) {
			console.error(error);
		}
		try {
			const res = await getExchange();

			const exchange = res.data.data.sort((a, b) => {
				const ad = new Date(a.updated_at);
				const bd = new Date(a.updated_at);
				if (Math.floor(ad - bd) >= 0) {
					return a - b;
				} else {
					return b - a;
				}
			});

			const setupExchange = res.data.data;

			if (setupExchange.length !== 0) {
				setupAction.updateBiz({
					...setupExchange[0].info.biz,
					EXCHANGE_NAME: setupExchange[0].display_name,
					NAME: setupExchange[0].info.biz.EXCHANGE_NAME,
					pairs: setupExchange[0].pairs,
					coins: setupExchange[0].coins,
					URL: setupExchange[0].url,
					DOMAIN: setupExchange[0].domain,
					smtp: setupExchange[0].smtp,
					id: setupExchange[0].id,
				});
				setupAction.updateTech({
					...setupExchange[0].info.tech,
					id: setupExchange[0].id,
					type: setupExchange[0].type,
				});
			}
			exchangeAction.updateData(exchange);
		} catch (error) {
			console.error(error);
		}
		try {
			const userInfo = await getUserInfo();
			this.props.userAction.readData(userInfo.data);
			this.setState(
				{
					hasPin: userInfo.data.pin,
					isLogin: true,
					isLoaded: true,
				},
				() => {
					showChat();
				}
			);
		} catch (error) {
			this.setState(
				{
					isLogin: false,
					isLoaded: true,
				},
				() => {
					removeCookie('id_token');
					hideChat();
				}
			);
		}
	};

	getAvailableCurrency = async () => {
		const { coinAction } = this.props;
		try {
			const res = await getCoins();
			const coins = await res.data.data.map((item) => {
				// NOTE: Monero set disabled
				if (item.symbol === 'xmr') {
					return {
						key: 'Monero',
						value: 'xmr',
						disabled: true,
						...item
					};
				}
				const filter = ASSET_TYPE_LIST.filter((obj) => obj.value === item.symbol);
				if (filter.length === 0) {
					return {
						key: item.fullname,
						value: item.symbol,
						...item
					};
				} else {
					return { ...filter[0], ...item };
				}
			});

			return coinAction.setCoin(coins);
		} catch (error) {
			throw error;
		}
	};

	getTradingPairs = async () => {
		const { pairAction } = this.props;
		try {
			const res = await getPairs();
			if (res.data && res.data.data) {
				pairAction.setPair(res.data.data);
			}
		} catch (error) {
			console.error(error);
		}
	};

	render() {
		const { isLoaded, isLogin } = this.state;
		const { user = {}, exchange } = this.props;
		const adjustHeight = !user.otp_enabled && exchange && exchange[0] && exchange[0].is_running;
		if (!isLoaded) return (
			<div
				style={{
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					height: '100vh'
				}}
			>
				<Spin />
			</div>
		);
		if (!isLogin) {
			return (
				<Switch>
					<Route path="/signup" component={() => {
						window.location.href = 'https://hollaex.com/start';
						return null;
					}} />
					{/* <Route path="/project">
						<Layout>
							<Header />
							<Content
								id="dash-main"
								style={{
									background: '#0E0E0F',
									padding: 0,
									margin: window.innerHeight <= 1025 ? 0 : 24,
									minHeight: window.innerHeight - 112,
								}}
							>
								<Route exact path="/project" component={ProjectList} />
								<Route exact path="/project/:id" component={Project} />
							</Content>
						</Layout>
					</Route> */}
					<Route path="/">
						<AuthWrapper>
							<Switch>
								<Route path="/login" component={Login} />
								<Route path="/verify" component={Verify} />
								<Route
									path="/email"
									component={ActivationEmailRequest}
								/>
								<Route path="/recover" component={RecoverAccount} />
								<Route path="/reset-password" component={ResetPw} />
								<Route path="/verify-code" component={VerifyCode} />
								<Route component={Login} />
							</Switch>
						</AuthWrapper>
					</Route>
				</Switch>
			);
		}
		return (
			<BrowserRouter>
				<Analytics id="UA-100799090-1" debug>
					<Wrapper>
						<Layout>
							<Layout>
								<Header />
								<Layout>
									<SideBar isMain={true}>
										<SideBarMain />
									</SideBar>
									<Content
										id="dash-main"
										style={{
											background: '#0E0E0F',
											padding: 0,
											margin: window.innerHeight <= 1025 ? 0 : 24,
											minHeight: window.innerHeight - 112,
											height: adjustHeight ? 'calc(100vh - 70px)' : 'calc(100vh - 40px)'
										}}
									>
										<Switch>
											<Route exact path="/" component={Home} />
											{/* Exchange Pages */}
											<Route exact path="/dashboard" component={Dashboard} />
											<Route exact path="/general" component={General} />
											<Route exact path="/users" component={Users} />

											<Route exact path="/help" component={Help} />

											{/* Wallet Pages */}
											{/* <Route path="/wallet" component={WalletList} /> */}
											<Route path="/wallet" component={Credit} />

											{/* Plugin Pages */}
											<Route exact path="/plugin" component={PluginApps} />
											{/* <Route path="/pluginhome" component={PluginHome} /> */}
											<Route path="/plugindetails" component={PluginDetails} />

											{/* Project Pages */}
											{/* <Route exact path="/project" component={ProjectList} />
											<Route exact path="/project/:id" component={Project} /> */}

											{/* collateral Page */}
											{/* <Route exact path="/collateral" component={ExchangeCollateral} /> */}

											{/* Credit Page */}
											{/* <Route path="/credit" component={Credit} /> */}
											<Route path="/confirm-withdraw/:id" component={Credit} />
											<Route path="/mypage" component={User} />

											{/* Financial page */}
											<Route path="/financial" component={Financial} />

											{/* Trading page */}
											<Route path="/trade" component={Trading} />

											{/* Member page
											<Route path="/members" component={Members} /> */}

											{/* User Tiers page
											<Route path="/tier" component={UserTiers} /> */}

											{/* Hosting page */}
											<Route path="/hosting" component={Hosting} />

											{/* Billing page */}
											<Route path="/billing" component={ExchangeBilling} />

											<Route path="/verifyagree" component={VerifyPage} />
											{/* Customize page*/}
											<Route path="/customize" component={CustomizeSection} />
											{/* Kyc page */}
											<Route path="/kyc" component={Kyc} />
											{/* API keys page */}
											{/* <Route path="/apikey" component={APIkeys} /> */}
										</Switch>
										<Switch>
											<Route path="/exchange/new" component={CreateExchange} />
											<Route
												exact
												path="/exchange/setup"
												component={CreateExchange}
											/>

											<Route path="/exchange" component={Exchange} />
										</Switch>
									</Content>
								</Layout>
							</Layout>
						</Layout>
					</Wrapper>
				</Analytics>
			</BrowserRouter>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		coin: state.coin,
		exchange: state.exchange,
		biz: state.biz,
		tech: state.tech,
		user: state.user
	};
};

const mapDispatchToProps = (dispatch) => ({
	coinAction: bindActionCreators(CoinAction, dispatch),
	userAction: bindActionCreators(UserAction, dispatch),
	exchangeAction: bindActionCreators(ExchangeAction, dispatch),
	setupAction: bindActionCreators(SetupAction, dispatch),
	pairAction: bindActionCreators(PairAction, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(Routes);
